var _mask, _path, _path2, _rect, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_31_1853",
    maskUnits: "userSpaceOnUse",
    x: 2.34766,
    y: 1.39056,
    width: 14,
    height: 14,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.34766,
    y: 1.39056,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2905 2.66671C14.6587 3.0349 14.6587 3.63185 14.2905 4.00004C13.9223 4.36823 13.3253 4.36823 12.9571 4.00004C12.589 3.63185 12.589 3.0349 12.9571 2.66671C13.3253 2.29852 13.9223 2.29852 14.2905 2.66671ZM4.2963 11.3276L12.1878 3.4361L13.5211 4.76943L5.62964 12.6609L4.2963 11.3276ZM4.95713 13.3335C5.32532 12.9653 5.32532 12.3684 4.95713 12.0002C4.58894 11.632 3.99199 11.632 3.6238 12.0002C3.25561 12.3684 3.25561 12.9653 3.6238 13.3335C3.99199 13.7017 4.58894 13.7017 4.95713 13.3335Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2905 2.66671C14.6587 3.0349 14.6587 3.63185 14.2905 4.00004C13.9223 4.36823 13.3253 4.36823 12.9571 4.00004C12.589 3.63185 12.589 3.0349 12.9571 2.66671C13.3253 2.29852 13.9223 2.29852 14.2905 2.66671ZM4.2963 11.3276L12.1878 3.4361L13.5211 4.76943L5.62964 12.6609L4.2963 11.3276ZM4.95713 13.3335C5.32532 12.9653 5.32532 12.3684 4.95713 12.0002C4.58894 11.632 3.99199 11.632 3.6238 12.0002C3.25561 12.3684 3.25561 12.9653 3.6238 13.3335C3.99199 13.7017 4.58894 13.7017 4.95713 13.3335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2905 2.66671L14.9976 1.9596L14.2905 2.66671ZM12.9571 2.66671L12.25 1.9596L12.9571 2.66671ZM12.1878 3.4361L12.8949 2.72899L12.1878 2.02189L11.4807 2.72899L12.1878 3.4361ZM4.2963 11.3276L3.5892 10.6205L2.88209 11.3276L3.5892 12.0347L4.2963 11.3276ZM13.5211 4.76943L14.2282 5.47654L14.9353 4.76943L14.2282 4.06233L13.5211 4.76943ZM5.62964 12.6609L4.92253 13.368L5.62964 14.0751L6.33674 13.368L5.62964 12.6609ZM3.6238 12.0002L4.33091 12.7073L3.6238 12.0002ZM3.6238 13.3335L4.33091 12.6264L3.6238 13.3335ZM14.9976 4.70715C15.7563 3.94843 15.7563 2.71831 14.9976 1.9596L13.5834 3.37381C13.561 3.35148 13.561 3.31527 13.5834 3.29293L14.9976 4.70715ZM12.25 4.70715C13.0088 5.46586 14.2389 5.46586 14.9976 4.70715L13.5834 3.29293C13.6057 3.2706 13.6419 3.2706 13.6643 3.29293L12.25 4.70715ZM12.25 1.9596C11.4913 2.71831 11.4913 3.94843 12.25 4.70715L13.6643 3.29293C13.6866 3.31527 13.6866 3.35148 13.6643 3.37381L12.25 1.9596ZM14.9976 1.9596C14.2389 1.20089 13.0088 1.20089 12.25 1.9596L13.6643 3.37381C13.6419 3.39615 13.6057 3.39615 13.5834 3.37381L14.9976 1.9596ZM11.4807 2.72899L3.5892 10.6205L5.00341 12.0347L12.8949 4.14321L11.4807 2.72899ZM14.2282 4.06233L12.8949 2.72899L11.4807 4.14321L12.814 5.47654L14.2282 4.06233ZM6.33674 13.368L14.2282 5.47654L12.814 4.06233L4.92253 11.9538L6.33674 13.368ZM3.5892 12.0347L4.92253 13.368L6.33674 11.9538L5.00341 10.6205L3.5892 12.0347ZM4.25003 12.7073C4.22769 12.6849 4.22769 12.6487 4.25003 12.6264L5.66424 14.0406C6.42295 13.2819 6.42295 12.0518 5.66424 11.2931L4.25003 12.7073ZM4.33091 12.7073C4.30857 12.7296 4.27236 12.7296 4.25003 12.7073L5.66424 11.2931C4.90552 10.5343 3.67541 10.5343 2.91669 11.2931L4.33091 12.7073ZM4.33091 12.6264C4.35324 12.6487 4.35324 12.6849 4.33091 12.7073L2.91669 11.2931C2.15798 12.0518 2.15798 13.2819 2.91669 14.0406L4.33091 12.6264ZM4.25003 12.6264C4.27236 12.6041 4.30857 12.6041 4.33091 12.6264L2.91669 14.0406C3.67541 14.7993 4.90552 14.7993 5.66424 14.0406L4.25003 12.6264Z",
    fill: "black",
    mask: "url(#path-1-outside-1_31_1853)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.62354,
    y: 12,
    width: 13.1993,
    height: 1.88562,
    transform: "rotate(-45 3.62354 12)",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6239,
    cy: 3.33328,
    r: 0.942809,
    transform: "rotate(-45 13.6239 3.33328)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.29036,
    cy: 12.6667,
    r: 0.942809,
    transform: "rotate(-45 4.29036 12.6667)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGan);
export default __webpack_public_path__ + "static/media/gan.8b9144fdc1dad58c246d8d7bb460f011.svg";
export { ForwardRef as ReactComponent };